// src/components/buyer-sales-list/hooks/use-order-filters.ts
import { useState, useCallback } from "react";
import { useDebouncedValue } from "@mantine/hooks";
import { IOrderFilters, defaultFilters } from "../types";

export const useOrderFilters = () => {
  const [filters, setFilters] = useState<IOrderFilters>(defaultFilters);

  const updateFilter = useCallback(<K extends keyof IOrderFilters>(key: K, value: IOrderFilters[K]) => {
    setFilters((prev) => ({ ...prev, [key]: value, page: 1 }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  const setPage = useCallback((page: number) => {
    setFilters((prev) => ({ ...prev, page }));
  }, []);

  const [debouncedFilters] = useDebouncedValue(filters, 300);

  return {
    filters,
    debouncedFilters,
    updateFilter,
    clearFilters,
    setPage,
  };
};
